import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { ActionSource } from 'owa-todo-types';
import type { TodoContextMenuState } from 'owa-todo-context-menu';
import type { QuickAddViewState } from 'owa-todo-views';
import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { OwaDate } from 'owa-datetime';
import { CalendarEventsFilters } from 'owa-calendar-events-filter';

export interface AgendaScenarioViewConfig {
    maxDays: number;
    showDateRangeFooter: boolean;
}

export interface AgendaScenario {
    selectedDate: OwaDate;
    selectedCalendarEventId: string;
    shouldAutoScroll: boolean;
    topOfListIndex: number;
    viewConfig: AgendaScenarioViewConfig;
    searchText: string | null;
    shouldShowTasks: boolean;
    shouldShowDeclinedEvents: boolean;
    todoView: {
        todoActionSource: ActionSource;
        currentEditingTodoId: string | null;
        contextMenuViewState: TodoContextMenuState | null;
        quickAddViewState: QuickAddViewState;
    };
    entrySource: QuickComposeEntrySourceType;
    currentFilters: (CalendarEventsFilters | string)[];
}

interface AgendaStore {
    scenarios: ObservableMap<string, AgendaScenario>;
}
const agendaStoreData: AgendaStore = {
    scenarios: new ObservableMap(),
};

export const getAgendaStore = createStore<AgendaStore>('agendaStore', agendaStoreData);
